import { render, staticRenderFns } from "./ColapsableEntradasTable.vue?vue&type=template&id=f42aef32&scoped=true"
import script from "./ColapsableEntradasTable.vue?vue&type=script&lang=ts"
export * from "./ColapsableEntradasTable.vue?vue&type=script&lang=ts"
import style0 from "./ColapsableEntradasTable.vue?vue&type=style&index=0&id=f42aef32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42aef32",
  null
  
)

export default component.exports